import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { ComponentSync, LL_V_L } from '@nu-art/thunderstorm-frontend';
import { asArray } from '@nu-art/ts-common';
import { ModuleFE_ContextRule } from '../../../../../_entity.js';
import './Renderer_ContextRuleHeader.scss';
export class Renderer_ContextRuleHeader extends ComponentSync {
    __onContextRulesUpdated = (...params) => {
        if (!this.mounted)
            return;
        const currentId = this.state.contextRule?._id;
        const items = asArray(params[1]);
        const updated = items.find(item => item._id === currentId);
        if (updated)
            this.setState({ contextRule: updated });
    };
    deriveStateFromProps(nextProps, state) {
        state.renderArgs = nextProps.renderArgs;
        if (state.renderArgs.itemId !== state.contextRule?._id)
            state.contextRule = ModuleFE_ContextRule.cache.unique(state.renderArgs.itemId);
        return state;
    }
    render() {
        return _jsxs(LL_V_L, { className: 'context-rule-header', children: [this.render_Title(), this.render_Subtitle()] });
    }
    render_Title = () => {
        return _jsx("div", { className: 'context-rule-header__title', children: this.state.contextRule?.label ?? 'N/A' });
    };
    render_Subtitle = () => {
        const contextRule = this.state.contextRule;
        if (!contextRule?.description)
            return;
        return _jsx("span", { className: 'context-rule-header__sub-title', children: contextRule.description });
    };
}
//# sourceMappingURL=Renderer_ContextRuleHeader.js.map